<template>
  <div class="v-stack h-stretch gap-3" v-if="$store.state.accessLevel > 9">
    <select v-model="userFilter" @input="onInput($event)">
      <option :value="'all'">All</option>
      <option :value="'crew'">All without Admin</option>
      <option v-for="user in users" :key="user._id" :value="user._id">
        {{ user.fullName }}
      </option>
    </select>
    <Hours
      :userFilter="userFilter"
      :period="period"
      :year="year"
      :month="month"
      :startDate="startDate"
      :endDate="endDate"
    ></Hours>
  </div>
</template>

<script>
import Hours from "@/components/Hours.vue";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      userFilter: "crew",
      users: [],
    };
  },
  components: {
    Hours,
  },
  props: {
    period: {
      type: String,
      default: () => "",
    },
    year: {
      type: String,
      default: () => "",
    },
    month: {
      type: Number,
      default: () => "",
    },
    startDate: {
      type: String,
      default: () => "",
    },
    endDate: {
      type: String,
      default: () => "",
    },
  },
  methods: {
    ...mapActions(["getCrewNames"]),
    onInput(event) {
      if (this.$route.query.user != event.target.value) {
        this.$router.push("/lifefinance/crewhours?user=" + event.target.value);
      }
    },
    refresh() {
      this.$emit("refresh");
    },
  },
  mounted() {
    this.getCrewNames()
      .then((users) => {
        this.users = users.sort((a, b) => a.fullName.localeCompare(b.fullName));
      })
      .catch((error) => {
        console.log(error);
      });

    if ("user" in this.$route.query) {
      if (this.$route.query.user) {
        this.userFilter = this.$route.query.user;
      } else {
        this.userFilter = null;
      }
    }
  },
};
</script>
